import { useSeason } from "@/context/SeasonContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CalendarDays } from "lucide-react";

export default function SeasonSelector({ compact = false }) {
  const { seasons, selectedSeasonId, selectSeason, activeSeason } = useSeason();
  if (!seasons?.length) return null;
  return (
    <div className={compact ? "flex items-center gap-2" : "flex items-center gap-2"} data-testid="season-selector-wrap">
      <CalendarDays className="w-4 h-4 text-zinc-500" />
      <Select value={selectedSeasonId || ""} onValueChange={selectSeason}>
        <SelectTrigger data-testid="season-selector" className={compact ? "h-8 w-[140px] text-xs" : "h-9 w-[160px]"}>
          <SelectValue placeholder="Stagione" />
        </SelectTrigger>
        <SelectContent>
          {seasons.map((s) => (
            <SelectItem key={s.id} value={s.id} data-testid={`season-opt-${s.id}`}>
              {s.name}{s.id === activeSeason?.id ? " · attiva" : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
